import Vue from "vue";

export function isLoggedIn() {
  const userInfo = Vue.prototype.$cookies.get("userInfo");
  return !!userInfo && !!userInfo.userid;
}
